enum ApplicationFeature {
  CampaignVariantsSection = 'campaignVariantsSection',
  VariantsSection = 'variantsSection',
  TechnicalSpecificationsSection = 'technicalSpecificationsSection',
  TrimEquipmentComparisonSection = 'trimEquipmentComparisonSection',
  ColorsSection = 'colorsSection',
  ChargingSubscriptionsSection = 'chargingSubscriptionsSection',
  DownloadPdf = 'downloadPdf',
  ShowWidgetImage = 'showWidgetImage',
  IsFirstColumnExpanded = 'isFirstColumnExpanded',
  BookCarOnline = 'bookCarOnline',
  AccessoriesSection = 'accessoriesSection',
  InteriorsSection = 'interiorsSection',
}

export default ApplicationFeature;
